import { MIN_SIZE } from './constants';

/**
 * Compute minimap pixel size and uniform scale from content bounds and max dimensions.
 */
export function calculateMinimapDimensions(bounds, maxDimensions) {
  const MAX_MINIMAP_WIDTH = maxDimensions.maxWidth;
  const MAX_MINIMAP_HEIGHT = maxDimensions.maxHeight;

  if (
    !bounds.width ||
    !bounds.height ||
    !isFinite(bounds.width) ||
    !isFinite(bounds.height)
  ) {
    return { minimapWidth: MIN_SIZE, minimapHeight: MIN_SIZE, scale: 1 };
  }

  const scaleToFitWidth = MAX_MINIMAP_WIDTH / bounds.width;
  const scaleToFitHeight = MAX_MINIMAP_HEIGHT / bounds.height;
  const uniformScale = Math.min(scaleToFitWidth, scaleToFitHeight);
  const width = bounds.width * uniformScale;
  const height = bounds.height * uniformScale;

  return {
    minimapWidth: Math.max(1, Math.round(width)),
    minimapHeight: Math.max(1, Math.round(height)),
    scale: uniformScale || 1,
  };
}
